module.exports = __webpack_public_path__ + "static/media/cannes.acd0dd19.svg";